import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, BehaviorSubject,forkJoin } from 'rxjs';
import { map } from 'rxjs/operators';
import { UserDetailModel, UserModel, VehicleModel, BankModel, DepartmentModel, UserDTO, VehicleConfigurationModel, AttachmentConfigurationModel, ApproveModel, StatusModel, UserServiceModel, VehicleCategoryTypeModel, UserPermissionModel, GenderModel, VehicleStatusModel, BankStatusModel, UserRegistrationModel, PartnerServiceModel, DriverRatingModel, UserTaxModel, VehicleTypeModel, FuleTypeModle, VehicleBrandModel, VehicleColorModel, DriverEditor, BillingModel, ReferredUserModel, ModificationDetailsModel,UserSubscriptionDTO,UserDataResponse } from './user.model';
import { BankStatusCD, ConfigurationEnum, Status, GenderEnum, VehicleTypeEnum } from '../../../shared/enum/base.enum';
import { LocalStorageService } from '../../../core/local-storage.service';
import { ObserveOnMessage } from 'rxjs/internal/operators/observeOn';
import { environment } from '../../../../environments/environment';
import { env } from 'process';
import { BankNameDropdown, DropdownModel, RegionModel } from '../../master/region/shared/region.model';

@Injectable({
    providedIn: 'root'
})
export class UserService {
    private subscriptionInfo: any;

    setSubscriptionInfo(info: any) {
        this.subscriptionInfo = info;
    }

    getSubscriptionInfo() {
        return this.subscriptionInfo;
    }
    downloadData = new BehaviorSubject(false);
    downloadProgress = this.downloadData.asObservable();

    public profileUpdate = new BehaviorSubject<any>({});
    profileUpdateEvent = this.profileUpdate.asObservable();

    constructor(private http: HttpClient,
        private localStorage: LocalStorageService) { }

    userDetail: any;

    changeDownloadStatus(value: boolean) {
        this.downloadData.next(value);
    }
    profileUpdateConfirmation(value: any) {
        this.profileUpdate.next(value);
    }

    getRegion(url, countryID, stateID): Observable<RegionModel[]> {
        if (countryID && !stateID) {
            url = url + '/getBycountryUId?countryUId=' + countryID;
        } else if (stateID) {
            url = url + '/getBystateUId?stateUId=' + stateID;
        }
        return this.http.get(url).pipe(map((response: RegionModel[]) => {
            return response;
        }));
    }
    getUserList(params): Observable<UserDetailModel> {
        // tslint:disable-next-line:max-line-length
        const url = environment.url + 'User/list';
        return this.http.get(url, { params: params }).pipe(map((response: UserDetailModel) => {
            return response;
        }));
    }
    getDriverUserList(params): Observable<UserDetailModel> {
        // tslint:disable-next-line:max-line-length
        const url = environment.url + 'User/Driverlist';
        return this.http.get(url, { params: params }).pipe(map((response: UserDetailModel) => {
            return response;
        }));
    }
    getAllNearByDriverList(params?: any): Observable<UserDetailModel> {
        // tslint:disable-next-line:max-line-length
        const url = environment.url + 'Shipment/all-near-by-drivers';
        return this.http.get<UserDetailModel>(url, params ? { params } : {}).pipe(map((response: UserDetailModel) => {
            return response;
        }));
    }

    getUserTaxDetails(uId): Observable<UserTaxModel> {
        // tslint:disable-next-line:max-line-length
        const url = environment.url + 'TaxIdentity/' + uId;
        return this.http.get(url).pipe(map((response: UserTaxModel) => {
            return response;
        }));
    }

    // AttachmentConfigurationModel
    getExpiredDocumentsList(uId): Observable<AttachmentConfigurationModel[]> {
        const url = environment.url + 'UserVehicle/expiry-documents/';
        return this.http.get(url + uId).pipe(map((res: AttachmentConfigurationModel[]) => {
            return res;
        }));
    }


    downloadUsers(data): Observable<any> {
        const url = environment.url + 'DataToFileConvertor/export-as-excel';
        // if (isPdf)
        //     url = 'DataToFileConvertor/export-as-pdf';
        return this.http.get(url, { params: data }).pipe(map((response: any) => {
            return response;
        }));
    }

    downloadUsersAsCSV(data): Observable<any> {
        const url = environment.url + 'DataToFileConvertor/export-as-csv';
        return this.http.get(url, { params: data }).pipe(map((response: any) => {
            return response;
        }));
    }

    downloadSellers(data): Observable<any> {
        const url = environment.seller_url + 'datatofile/export-as-excel';
        return this.http.get(url, { params: data }).pipe(map((response: any) => {
            return response;
        }));
    }

    downloadFile(uId): Observable<any> {
        const url = environment.url + 'FileCreationDownload/' + uId;
        return this.http.get(url,).pipe(map((response: any) => {
            return response;
        }));
    }


    downloadFileFromMaster(uId): Observable<any> {
        const url = environment.master_url + 'file/creation/download/' + uId;
        return this.http.get(url,).pipe(map((response: any) => {
            return response;
        }));
    }




    getStaffByUid(uId): Observable<UserDataResponse> {
        const url = environment.url + 'User/' + uId;
        const SubscriptionUrl = environment.payment_url + 'Subscription/Validate-Plan-Subscription?UserId=' + uId; 
        const otherData$ = this.http.get(SubscriptionUrl).pipe(map((otherData: UserSubscriptionDTO) => otherData));
        const user$ = this.http.get(url).pipe(map((userData: UserDTO) => userData));
      
        return forkJoin([user$, otherData$]).pipe(
          map(([userData, otherData]) => {
            return new UserDataResponse(userData, otherData);
          })
        );
      }      


    registerDriver(data, value): Observable<UserRegistrationModel> {
        const url = environment.url + 'RegistrationPhase';
        if (data.uId || (value === VehicleTypeEnum.BICYCLE || value === VehicleTypeEnum.MOTORCYCLE)) {
            return this.http.put(url, data).pipe(map((response: UserRegistrationModel) => {
                return response;
            }));
        } else {
            return this.http.post(url, data).pipe(map((response: UserRegistrationModel) => {
                return response;
            }));
        }

    }

    changeRegistrationDocumentStatus(data): Observable<any> {
        let url: string = '';
        if (data.expiryDate) {
            url = environment.url + 'RegistrationPhase/approveDocument';
        } else if (data.remark) {
            url = environment.url + 'RegistrationPhase/rejectDocument';
        }
        return this.http.put(url, data).pipe(map((response: any) => {
            return response;
        }));
    }

    changeVehicleIdentityStatus(data, value): Observable<any> {
        let url: string = '';
        if (value) {
            url = environment.url + 'UserIdentity/approveDocument';
        } else {
            url = environment.url + 'UserIdentity/rejectDocument';
        }
        return this.http.put(url, data).pipe(map((response: any) => {
            return response;
        }));
    }

    getDocuments(uId, countryUId): Observable<AttachmentConfigurationModel[]> {
        const url = environment.url + 'UserIdentity/' + uId + '/' + countryUId;
        return this.http.get(url).pipe(map((response: AttachmentConfigurationModel[]) => {
            return response;
        }));
    }

    deleteDocument(uId): Observable<boolean> {
        const url = environment.url + 'UserIdentity/' + uId;
        return this.http.delete(url).pipe(map((response: boolean) => {
            return response;
        }));
    }



    saveStaff(data): Observable<UserModel> {
        const url = environment.url + 'User';
        return this.http.post(url, data).pipe(map((response: UserModel) => {
            return response;
        }));

    }

    saveBillingInfo(data): Observable<any> {
        const url = environment.url + 'User/update/billing-info';
        return this.http.put(url, data).pipe(map((response: any) => {
            return response;
        }));

    }

    updateStaff(data): Observable<UserModel> {
        const url = environment.url + 'User';
        return this.http.put(url, data).pipe(map((response: UserModel) => {
            return response;
        }));
    }

    updateStatus(obj): Observable<number> {
        let url: string = "";
        if (obj.isApprove === Status.Approve) {
            url = environment.url + 'User/approve';
        } else if (obj.isApprove === Status.Reject) {
            url = environment.url + 'User/reject';
        } else if (obj.isApprove === Status.Block) {
            url = environment.url + 'User/block';
        } else if (obj.isApprove === Status.Unblock) {
            url = environment.url + 'User/unblock';
        } else if (obj.isApprove === Status.Unsubscribe) {
            url = environment.url + 'User/unSubscribe';
        }
        return this.http.put(url, obj).pipe(map((response: number) => {
            return response;
        }));
    }



    approveDocuments(data, obj): Observable<number> {
        let url: string = '';

        if (obj.isApprove === Status.Approve) {
            url = environment.url + 'UserIdentity/approve';
        } else if (obj.isApprove === Status.Reject) {
            url = environment.url + 'UserIdentity/reject';
        }
        return this.http.put(url, data).pipe(map((response: number) => {
            return response;
        }));
    }



    approveAddress(data): Observable<number> {
        let url = environment.url + 'User/update-address-status';
        return this.http.put(url, data).pipe(map((response: number) => {
            return response;
        }));
    }

    getVehicleListByUid(uId): Observable<VehicleModel[]> {
        const url = environment.url + 'UserVehicle/list/';
        return this.http.get(url + uId).pipe(map((response: VehicleModel[]) => {
            return response;
        }));
    }

    getVehicleInfoByUid(uId): Observable<VehicleConfigurationModel> {
        const url = environment.url + 'UserVehicle/';
        return this.http.get(url + uId).pipe(map((response: VehicleConfigurationModel) => {
            return response;
        }));
    }

    saveVehicle(data): Observable<any> {
        //    const url = "http://192.168.1.56:6005/api/UserVehicle/save-vehicle"
        const url = environment.url + 'UserVehicle/save-vehicle';
        return this.http.post(url, data).pipe(map((response: any) => {
            return response;
        }));
    }

    enableDisable(data): Observable<any> {
        const url =  environment.url + 'UserVehicle/enable-disable';
        return this.http.put(url, data).pipe(map((response: any) => {
            return response;
        }));
    }


    getVehicleTypes(): Observable<VehicleTypeModel[]> {
        const url = environment.url + 'VehicleType/ddo';
        return this.http.get(url).pipe(map((response: VehicleTypeModel[]) => {
            response.forEach(res => {
                res.label = res.name;
                res.value = res.uId;
            })
            return response;
        }));
    }


    getFuleType(): Observable<FuleTypeModle[]> {
        const url = environment.url + 'FuelType/list';
        return this.http.get(url).pipe(map((response: FuleTypeModle[]) => {
            response.forEach(res => {
                res.label = res.fuelName;
                res.value = res.id;
            })
            return response;
        }));
    }

    updateUserPersonalInfo(data): Observable<UserModel[]> {
        const url = environment.url + 'User';
        return this.http.put(url, data).pipe(map((response: UserModel[]) => {
            return response;
        }));
    }
    getVehicleBrand(vehicleTypeId): Observable<VehicleBrandModel[]> {
        const url = environment.url + 'VehicleBrand/getDDO?vehicleTypeId=' + vehicleTypeId;
        return this.http.get(url).pipe(map((response: VehicleBrandModel[]) => {
            response.forEach(res => {
                res.label = res.name;
                res.value = res.uId;
            })
            return response;
        }));

    }
    getVehicleColor(groupId, languageCode): Observable<VehicleColorModel[]> {
        const url = environment.url + 'ConfigCD/' + groupId + '?languageCode=' + languageCode
        return this.http.get(url).pipe(map((response: VehicleColorModel[]) => {
            response.forEach(res => {
                res.label = res.cdValue;
                res.value = res.id
            })
            return response;
        }));

    }

    getVehicleUse(groupId, languageCode): Observable<any> {
        const url = environment.url + 'ConfigCD/' + groupId + '?languageCode=' + languageCode
        return this.http.get(url).pipe(map((response: any) => {
            response.forEach(res => {
                res.label = res.cdValue;
                res.value = res.id
            })
            return response;
        }));

    }


    deleteVehicleAttachment(uId): Observable<any> {
        const url = environment.url + 'AttachmentConfiguration/delete/' + uId;
        return this.http.delete(url, {}).pipe((map((res: any) => {
            return res;
        })));
    }

    deleteVehicleAttachmentNew(uId, vehicleUId): Observable<any> {

        const url = environment.url + 'UserVehicle/delete-file/' + uId + '/' + vehicleUId;

        return this.http.delete(url, {}).pipe((map((res: any) => {

            return res;

        })));

    }

    saveVehicleAttachment(data): Observable<AttachmentConfigurationModel> {
        const url = environment.url + 'UserVehicle/save-file';
        return this.http.post(url, data).pipe(map((response: AttachmentConfigurationModel) => {
            return response;
        }));
    }

    savePersonalDocument(data): Observable<AttachmentConfigurationModel> {
        const url = environment.url + 'UserIdentity/save-file';
        return this.http.post(url, data).pipe(map((response: AttachmentConfigurationModel) => {
            return response;
        }));
    }


    savePersonalDocument2(data): Observable<AttachmentConfigurationModel> {
        const url = environment.url + 'RegistrationPhase/upload-file';
        return this.http.post(url, data).pipe(map((response: AttachmentConfigurationModel) => {
            return response;
        }));
    }

    getVehicleCategory(uId): Observable<VehicleCategoryTypeModel[]> {
        const url = environment.url + 'VehicleCategory/getAll/';
        return this.http.get(url + uId).pipe(map((response: VehicleCategoryTypeModel[]) => {
            return response;
        }));
    }

    getUserPermission(): Observable<UserPermissionModel[]> {
        const url = environment.url + 'UserPermission';
        return this.http.get(url).pipe(map((response: UserPermissionModel[]) => {
            return response;
        }));
    }

    updateVehicleCategory(data): Observable<boolean> {
        const url = environment.url + 'UserVehicle/update-vehicle-category';
        return this.http.put(url, data).pipe(map((response: boolean) => {
            return response;
        }));
    }


    approveVehicle(data, event): Observable<number> {
        let url: string = "";
        if (event.isApprove === Status.Approve) {
            url = environment.url + 'UserVehicle/approve';
        } else if (event.isApprove === Status.Reject) {
            url = environment.url + 'UserVehicle/reject';
        } else if (event.isApprove == Status.Remove){
            url = environment.url + 'UserVehicle/deactivate';
        }
        
        return this.http.put(url, data).pipe(map((response: number) => {
            return response;
        }));
    }

    getUserBankDetails(uId): Observable<BankModel[]> {
        const url = environment.url + 'UserBankDetail/list/';
        return this.http.get(url + uId).pipe(map((response: BankModel[]) => {
            return response;
        }));
    }

    getBankInfoByUid(uId): Observable<BankModel> {
        const url = environment.url + 'UserBankDetail/';
        return this.http.get(url + uId).pipe(map((response: BankModel) => {
            return response;
        }));
    }

    approveVehicleDocuments(data, value): Observable<number> {
        let url;
        if (value) {
            url = environment.url + 'UserVehicle/approveDocument';
        } else {
            url = environment.url + 'UserVehicle/rejectDocument';

        }
        return this.http.put(url, data).pipe(map((response: number) => {
            return response;
        }));
    }

    approveBank(data): Observable<number> {
        let url;
        const obj = {
            uId: data.uId,
            remark: data.remarks
        };
        if (data.bankStatusCD === BankStatusCD.Approved) {
            url = environment.url + 'UserBankDetail/approve';
        } else if (data.bankStatusCD === BankStatusCD.Rejected) {
            url = environment.url + 'UserBankDetail/reject';
        } else if (data.bankStatusCD === BankStatusCD.OnHold) {
            url = environment.url + 'UserBankDetail/hold';
        }
        return this.http.put(url, obj).pipe(map((response: number) => {
            return response;
        }));
    }

    // updateBankStatus(data): Observable<number> {
    //     let url;
    //     const obj = {
    //         uId: data.uId,
    //         remark: data.remarks
    //     };
    //     if (data.isActive === 'true') {
    //         url = 'UserBankDetail/activate';
    //     } else {
    //         url = 'UserBankDetail/de-activate';
    //     }
    //     return this.http.put(url, obj).pipe(map((response: number) => {
    //         return response;
    //     }));
    // }

    getDepartmentList(): Observable<DepartmentModel[]> {
        const url = environment.url + 'Department';
        return this.http.get(url).pipe(map((response: DepartmentModel[]) => {
            return response;
        }));
    }

    getDesignationList(): Observable<DepartmentModel[]> {
        const url = environment.url + 'Designation';
        return this.http.get(url).pipe(map((response: DepartmentModel[]) => {
            return response;
        }));
    }

    getServicesList(uId): Observable<UserServiceModel[]> {
        const url = environment.url + 'UserService/services/';
        return this.http.get(url + uId).pipe(map((response: UserServiceModel[]) => {
            return response;
        }));
    }


    blockUnblockService(data): Observable<UserServiceModel> {
        const url = environment.url + 'UserService/block-unBlock';
        return this.http.put(url, data).pipe(map((response: UserServiceModel) => {
            return response;
        }));
    }

    validateUserBlock(uId): Observable<boolean> {
        const url = environment.url + 'Order/validate-user-block/';
        return this.http.get(url + uId).pipe(map((response: boolean) => {
            return response;
        }));
    }
    validateUserUnSubscribe(uId): Observable<boolean> {
        const url = environment.url + 'Order/validate-user-unsubscribe/';
        return this.http.get(url + uId).pipe(map((response: boolean) => {
            return response;
        }));
    }

    deleteUser(userUId, roleId): Observable<boolean> {
        const url = environment.url + 'Order/delete-user/' + userUId + '/' + roleId;
        return this.http.put(url, null).pipe(map((response: boolean) => {
            return response;
        }));
    }

    permanentlyDeleteUser(data): Observable<number> {
        const url = environment.url + 'User/delete-permanently';
        return this.http.put(url, data).pipe(map((response: number) => {
            return response;
        }));
    }


    restoreUser(data): Observable<number> {
        const url = environment.url + 'User/restore';
        return this.http.put(url, data).pipe(map((response: number) => {
            return response;
        }));
    }

    retreiveDriverServices(params, value): Observable<PartnerServiceModel> {
        const url = environment.url + value;
        return this.http.get(url, { params: params }).pipe(map((response: PartnerServiceModel) => {
            return response;
        }));
    }

    retreiveDriverRating(driverUrl, value): Observable<DriverRatingModel> {
        const url = environment.url + driverUrl + value;
        return this.http.get(url).pipe(map((response: DriverRatingModel) => {
            return response;
        }));
    }

    retreiveDriverFoodRating(driverUrl, value): Observable<DriverRatingModel> {
        const url = environment.order_url + driverUrl + value;
        return this.http.get(url).pipe(map((response: DriverRatingModel) => {
            return response;
        }));
    }

    updateDriverStatus(data): Observable<number> {
        const url = environment.url + 'User/activate-deActivate';
        return this.http.put(url, data).pipe(map((response: number) => {
            return response;
        }));
    }

    schedulePhase4Appointment(data): Observable<number> {
        const url = data.uId ? environment.url + 'VehiclePhysicalReview/re-schedule' : environment.url + 'VehiclePhysicalReview';
        if (data.uId) {
            return this.http.put(url, data).pipe(map((response: number) => {
                return response;
            }));
        } else {
            return this.http.post(url, data).pipe(map((response: number) => {
                return response;
            }));
        }

    }

    updatePhysicalReviewStatus(data): Observable<number> {
        const url = environment.url + 'VehiclePhysicalReview/update-status';
        return this.http.put(url, data).pipe(map((response: number) => {
            return response;
        }));
    }


    getStaffColumns(languageCode) {
        return [
            {
                field: 'fullName',
                header: this.localStorage.getSelectedLanguageValue('General.Name'),
                showCheckbox: true,
                isShow: true, width: '8vw'
            },
            {
                field: 'email',
                header: this.localStorage.getSelectedLanguageValue('General.Email'),
                isShow: true, width: '12%'
            },
            {
                field: 'mobileNo',
                header: this.localStorage.getSelectedLanguageValue('General.MobileNo'),
                isShow: true, width: '8vw'
            },
            {
                field: 'departmentName',
                header: this.localStorage.getSelectedLanguageValue('General.DepartmentName'),
                isShow: true, width: '8vw'
            },
            {
                field: 'designationName',
                header: this.localStorage.getSelectedLanguageValue('General.DesignationName'),
                isShow: true, width: '8vw'
            },
            {
                field: 'registrationDate',
                header: this.localStorage.getSelectedLanguageValue('General.RegistrationDate'),
                isShow: true, width: '8vw'
            },
            {
                field: 'countryName',
                header: this.localStorage.getSelectedLanguageValue('General.Country'),
                isShow: true, width: '8vw'
            },
            {
                field: 'userStatusCDName',
                header: this.localStorage.getSelectedLanguageValue('General.Status'),
                isShow: true, width: '8vw'
            },
            {
                field: 'action',
                header: this.localStorage.getSelectedLanguageValue('General.Action'),
                class1: 'fa fa-eye', isShow: false, width: '5vw'
            },
        ];
    }

    getDeliveryAssociateFrozenColumns(languageCode) {
        return [
            {
                field: 'fullName',
                header: this.localStorage.getSelectedLanguageValue('General.Name'),
                showCheckbox: true,
                isShow: true, width: '10vw'
            },
            {
                field: 'fatherLastName',
                header: this.localStorage.getSelectedLanguageValue('General.FatherLastName'),
                showCheckbox: true,
                isShow: true, width: '11vw'
            },
            {
                field: 'motherLastName',
                header: this.localStorage.getSelectedLanguageValue('General.MotherLastName'),
                showCheckbox: true,
                isShow: true, width: '11vw'
            },
            {
                field: 'email',
                header: this.localStorage.getSelectedLanguageValue('General.Email'),
                isShow: true, width: '11vw'
            },
        ];
    }

    getDeliveryAssociateScrollableColumns(languageCode) {
        return [
            {
                field: 'mobileNo',
                header: this.localStorage.getSelectedLanguageValue('General.MobileNo'),
                isShow: true, width: '12vw'
            },
            {
                field: 'uId',
                header: this.localStorage.getSelectedLanguageValue('General.PartnerCode'),
                isShow: false, width: '10vw'
            },
            {
                field: 'countryName',
                header: this.localStorage.getSelectedLanguageValue('General.Country'),
                isShow: true, width: '8vw'
            },
            {
                field: 'stateName',
                header: this.localStorage.getSelectedLanguageValue('General.State'),
                isShow: true, width: '8vw'
            },
            {
                field: 'cityName',
                header: this.localStorage.getSelectedLanguageValue('General.City'),
                isShow: true, width: '8vw'
            },
            {
                field: 'registrationDate',
                header: this.localStorage.getSelectedLanguageValue('General.RegistrationDate'),
                isShow: false, width: '11vw'
            },
            {
                field: 'expiryDocumentCount',
                header: this.localStorage.getSelectedLanguageValue('General.ExpiredVehicleCount'),
                toolTip: this.localStorage.getSelectedLanguageValue('General.Expiredvehicledocument'),
                isShow: false, width: '16vw'
            },
            {
                field: 'userStatusCDName',
                header: this.localStorage.getSelectedLanguageValue('General.ProfileStatus'),
                isShow: false, width: '15vw'
            },
            {
                field: 'userServices',
                header: this.localStorage.getSelectedLanguageValue('General.Services'),
                isShow: false, width: '9vw'
            },
            {
                field: 'totalRides',
                header: this.localStorage.getSelectedLanguageValue('General.TotalRides'),
                isShow: false, width: '10vw'
            },
            {
                field: 'rideAvgRating',
                header: this.localStorage.getSelectedLanguageValue('General.Rating'),
                isShow: false, width: '8vw', padding: '0', fontSize: '.8em'
            },
            {
                field: 'totalShipments',
                header: this.localStorage.getSelectedLanguageValue('General.Total Shipment'),
                isShow: true, width: '11vw'
            },
            {
                field: 'shipmentAvgRating',
                header: this.localStorage.getSelectedLanguageValue('General.Rating'),
                isShow: false, width: '8vw', padding: '0', fontSize: '.8em'
            },
            {
                field: 'totalFoodOrders',
                header: this.localStorage.getSelectedLanguageValue('General.TotalFoodOrders'),
                isShow: false, width: '18vw'
            },
            {
                field: 'foodAvgRating',
                header: this.localStorage.getSelectedLanguageValue('General.Rating'),
                isShow: false, width: '8vw', padding: '0', fontSize: '.8em'
            },
            {
                field: 'action',
                header: this.localStorage.getSelectedLanguageValue('General.Action'),
                class1: 'fa fa-eye', isShow: false, width: '17vw'
            },

        ];
    }
    // expiryDocumentCount
    getUserColumns(languageCode) {
        return [
            {
                field: 'fullName',
                header: this.localStorage.getSelectedLanguageValue('General.Name'),
                showCheckbox: true,
                isShow: true, width: '4vw'
            },
            {
                field: 'email',
                header: this.localStorage.getSelectedLanguageValue('General.Email'),
                isShow: true, width: '5vw'
            },
            {
                field: 'mobileNo',
                header: this.localStorage.getSelectedLanguageValue('General.MobileNo'),
                isShow: true, width: '2.5vw'
            },
            {
                field: 'countryName',
                header: this.localStorage.getSelectedLanguageValue('General.Country'),
                isShow: true, width: '3vw'
            },
            {
                field: 'registrationDate',
                header: this.localStorage.getSelectedLanguageValue('General.RegistrationDate'),
                isShow: true, width: '2.3vw'
            },
            {
                field: 'userStatusCDName',
                header: this.localStorage.getSelectedLanguageValue('General.Status'),
                isShow: true, width: '3vw'
            },
            {
                field: 'action',
                header: this.localStorage.getSelectedLanguageValue('General.Action'),
                class1: 'fa fa-eye', isShow: false, width: '2.5vw', headerWidth: '2vw'
            },
        ];
    }
    getBankColumns() {
        return [
            {
                field: 'accHolderName',
                header: this.localStorage.getSelectedLanguageValue('General.AccountHolderName')
                , isShow: true,
            },
            {
                field: 'accountNumber',
                header: this.localStorage.getSelectedLanguageValue('General.AccountNumber'), isShow: true
            },
            {
                field: 'isDefault',
                header: this.localStorage.getSelectedLanguageValue('General.Default'),
                isShow: true
            },
            {
                field: 'bankStatus',
                header: this.localStorage.getSelectedLanguageValue('General.Status')
                , isShow: true
            },
            {
                field: 'action',
                header: this.localStorage.getSelectedLanguageValue('General.Action'), class: 'fa fa-eye', isShow: false
            },

        ];
    }

    getVehicleColumns(languageCode) {
        return [
            {
                field: 'vehicleSubBrand',
                header: this.localStorage.getSelectedLanguageValue('General.VehicleName'),
                isShow: true, width: '13vw'
            },
            {
                field: 'vehicleTypeName',
                header: this.localStorage.getSelectedLanguageValue('General.VehicleType'),
                isShow: true, width: '11vw'
            },
            {
                field: 'vehicleColorCDName',
                header: this.localStorage.getSelectedLanguageValue('General.VehicleColor'),
                isShow: true, width: '8vw'
            },
            {
                field: 'plateNumber',
                header: this.localStorage.getSelectedLanguageValue('General.PlateNumber'),
                isShow: true, width: '9vw'
            },
            {
                field: 'registrationYear',
                header: this.localStorage.getSelectedLanguageValue('General.RegistrationYear'),
                isShow: true, width: '12vw'
            },
            {
                field: 'status',
                header: this.localStorage.getSelectedLanguageValue('General.Status'),
                isShow: true, width: '11vw'
            },
            {
                field: 'isEnable',
                header: this.localStorage.getSelectedLanguageValue('General.Enabled'), isShow: true, width: '8vw'
            },
            {
                field: 'action',
                header: this.localStorage.getSelectedLanguageValue('General.Action'),
                class: 'fa fa-eye', isShow: false, width: '6vw'
            },
        ];
    }


    getDriverRideColumns() {
        return [
            { field: 'driverUId', header: this.localStorage.getSelectedLanguageValue('General.PartnerCode'), isShow: true, width: '4.5vw' },
            { field: 'driverName', header: this.localStorage.getSelectedLanguageValue('General.PartnerName'), isShow: true, width: '5vw' },
            { field: 'orderNumber', header: this.localStorage.getSelectedLanguageValue('General.OrderNumber'), isShow: true, width: '4.9vw' },
            { field: 'totalAmount', header: this.localStorage.getSelectedLanguageValue('General.TotalAmount'), isShow: true, width: '4vw' },
            { field: 'orderDate', header: this.localStorage.getSelectedLanguageValue('General.OrderDate'), isShow: true, width: '5vw' },
            { field: 'paymentMode', header: this.localStorage.getSelectedLanguageValue('General.PaymentMode'), isShow: true, width: '4vw' },
            { field: 'customerName', header: this.localStorage.getSelectedLanguageValue('General.UserName'), isShow: true, width: '5vw' },
            { field: 'customerUId', header: this.localStorage.getSelectedLanguageValue('General.UserCode'), isShow: true, width: '3.3vw' },
            { field: 'daRatingValue', header: this.localStorage.getSelectedLanguageValue('General.Rating'), isShow: true, width: '4vw' },
            { field: 'orderStatus', header: this.localStorage.getSelectedLanguageValue('General.Status'), isShow: true, width: '4vw' },
            { field: 'action', header: this.localStorage.getSelectedLanguageValue('General.Action'), class1: 'fa fa-eye', isShow: false, width: '2.2vw' },
        ];
    }

    getDriverShipmentColumns() {
        return [
            { field: 'driverUId', header: this.localStorage.getSelectedLanguageValue('General.PartnerCode'), isShow: true, width: '4.2vw' },
            { field: 'orderNumber', header: this.localStorage.getSelectedLanguageValue('General.OrderNumber'), width: '4vw' },
            { field: 'driverName', header: this.localStorage.getSelectedLanguageValue('General.PartnerName'), isShow: true, width: '3.3vw' },
            { field: 'totalAmount', header: this.localStorage.getSelectedLanguageValue('General.TotalAmount'), width: '3vw' },
            { field: 'orderDate', header: this.localStorage.getSelectedLanguageValue('General.OrderDate'), width: '4vw' },
            { field: 'customerUId', header: this.localStorage.getSelectedLanguageValue('General.UserCode'), isShow: true, width: '3.3vw' },
            { field: 'customerName', header: this.localStorage.getSelectedLanguageValue('General.UserName'), isShow: true, width: '3.3vw' },
            { field: 'carrierName', header: this.localStorage.getSelectedLanguageValue('General.Carrier'), width: '3vw' },
            { field: 'paymentMode', header: this.localStorage.getSelectedLanguageValue('General.PaymentMode'), width: '3.5vw' },
            { field: 'daRatingValue', header: this.localStorage.getSelectedLanguageValue('General.Rating'), isShow: true, width: '3.3vw' },
            { field: 'deliveryMode', header: this.localStorage.getSelectedLanguageValue('General.DeliveryMode'), width: '3vw' },
            { field: 'orderStatus', header: this.localStorage.getSelectedLanguageValue('General.Status'), width: '3.2vw' },
            { field: 'action', header: this.localStorage.getSelectedLanguageValue('General.Action'), class1: 'fa fa-eye', width: '2.2vw' }
        ];
    }




    getStatusList(languageCode, status): Observable<StatusModel[]> {
        const url = environment.url + 'ConfigCD/';
        return this.http.get(url + status + '?languageCode=' + languageCode).pipe(map((response: StatusModel[]) => {
            response.map((res) => {
                res.label = res.cdValue;
                res.value = res.uId;
            })
            return response;
        }));
    }

    getGenderList(languageCode): Observable<GenderModel[]> {
        const url = environment.url + 'ConfigCD/';
        return this.http.get(url + GenderEnum.GenderValue + '?languageCode=' + languageCode).pipe(map((response: GenderModel[]) => {
            response.map((res) => {
                res.label = res.cdValue;
                res.value = res.id;
            });
            return response;
        }));
    }

    getExpiryDropdown(languageCode) {
        return [
            {
                label: this.localStorage.getSelectedLanguageValue('General.All'),
                value: 0
            },
            {
                label: this.localStorage.getSelectedLanguageValue('General.Expired'),
                value: 1
            },
            {
                label: this.localStorage.getSelectedLanguageValue('General.YetToExpire'),
                value: 2
            },

        ]

    }

    getVehicleStatusList(languageCode): Observable<VehicleStatusModel[]> {
        const url = environment.url + 'ConfigCD/';
        return this.http.get(url + ConfigurationEnum.VEHICLE_STATUS + '?languageCode=' + languageCode).pipe(map((response: VehicleStatusModel[]) => {
            response.unshift({
                cdDesc: this.localStorage.getSelectedLanguageValue('General.All'),
                cdDesc_es_mx: "",
                cdValue: this.localStorage.getSelectedLanguageValue('General.All'),
                cdValue_es_mx: "",
                configCDGroupId: 0,
                createdDateTime: "",
                displayOrder: 0,
                id: undefined,
                isActive: false,
                isForRide: false,
                label: "",
                modifiedDateTime: "",
                uId: undefined,
                value: undefined

            });
            response.map((res) => {
                res.label = res.cdValue;
                res.value = res.uId;
            })
            return response;
        }));
    }

    getBankStatus(languageCode): Observable<BankStatusModel[]> {
        const url = environment.url + 'ConfigCD/';
        return this.http.get(url + ConfigurationEnum.BANK_STATUS + '?languageCode=' + languageCode).pipe(map((response: BankStatusModel[]) => {
            response.unshift({
                cdDesc: this.localStorage.getSelectedLanguageValue('General.All'),
                cdDesc_es_mx: "",
                cdValue: this.localStorage.getSelectedLanguageValue('General.All'),
                cdValue_es_mx: "",
                configCDGroupId: 0,
                createdDateTime: "",
                displayOrder: 0,
                id: undefined,
                isActive: false,
                isForRide: false,
                label: "",
                modifiedDateTime: "",
                uId: undefined,
                value: undefined

            });
            response.map((res) => {
                res.label = res.cdValue;
                res.value = res.uId;
            })
            return response;
        }));
    }

    generateArrayOfYears() {
        var max = new Date().getFullYear()
        var min = max - 5;
        var years = []

        for (var i = max; i >= min; i--) {
            const obj = {
                label: i,
                value: i
            }
            years.push(obj)
        }
        years.unshift({
            label: 'All',
            value: undefined
        })
        return years
    }

    approvePhaseWise(obj) {
        const url = environment.url + "User/approve-phase-wise/";

        var result = this.http.put(url, obj);
        return result;
    }

    rejectPhaseWise(obj) {
        const url = environment.url + "User/reject-phase-wise/";

        var result = this.http.put(url, obj);
        return result;
    }

    validatePhase2(userUId: string) {
        const url = environment.url + "User/validate-phase2/" + userUId;

        var result = this.http.get(url);
        return result;
    }

    deletePersonalDocument2(attachmentUId, userUId): Observable<any> {
        const url = environment.url + 'RegistrationPhase/delete-file/' + attachmentUId + '/' + userUId;
        return this.http.delete(url).pipe(map((response: any) => {
            return response;
        }));
    }

    addPartnerEditor(data: DriverEditor): Observable<UserModel> {
        const url = environment.url + "PartnerEditor"
        return this.http.post(url, data).pipe(map((response: UserModel) => {
            return response;
        }));
    }

    uploadProfilePic(data): Observable<any> {
        const url = environment.url + 'AttachmentConfiguration/upload-profile-image';
        return this.http.put(url, data).pipe(map((response: any) => {
            return response;
        }));
    }

    addTaxEditor(data): Observable<any> {
        const url = environment.url + 'PartnerEditor/add-billing-info';
        return this.http.post(url, data).pipe(map((response: any) => {
            return response;
        }));
    }

    serviceDropdown(): Observable<UserServiceModel[]> {
        const url = environment.url + 'UserService/services';
        return this.http.get(url).pipe(map((response: UserServiceModel[]) => {
            return response;
        }));
    }

    validateService(uId): Observable<UserServiceModel[]> {
        const url = environment.url + 'PartnerEditor/uId?partnerUId=';
        return this.http.get(url + uId).pipe(map((response: UserServiceModel[]) => {
            return response;
        }));
    }

    examComplete(uId, examCategoryUId): Observable<any> {
        const url = environment.url + 'PartnerEditor/submit-exam?partnerUId=' + uId + '&categoryUId=' + examCategoryUId;
        return this.http.put(url, uId).pipe(map((response: any) => {
            return response;
        }));
    }

    getTaxDetails(uId): Observable<UserTaxModel> {
        const url = environment.url + 'TaxIdentity/partnerUId?partnerUId=' + uId;
        return this.http.get(url).pipe(map((response: UserTaxModel) => {
            return response;
        }));
    }

    uploadTaxDoucment(data): Observable<any> {
        const url = environment.url + 'PartnerEditor/upload-tax-document';
        return this.http.post(url, data).pipe(map((response: any) => {
            return response;
        }));
    }

    getBankNameDropdown(countryUId): Observable<BankNameDropdown[]> {
        const url = environment.url + 'BankConfiguration/countryUId?countryUId=' + countryUId;
        return this.http.get(url).pipe(map((response: BankNameDropdown[]) => {
            return response;
        }));
    }

    saveBankInfo(bankInfo: BankModel): Observable<boolean> {
        const url = environment.url + 'UserBankDetail/add-or-update';
        return this.http.post(url, bankInfo).pipe(map((response: boolean) => {
            return response;
        }));
    }

    isPartnerApproved(userUId: string): Observable<boolean> {
        const url = environment.url + 'User/is-partner-approved/' + userUId;
        return this.http.get(url).pipe(map((response: boolean) => {
            return response;
        }));
    }

    getUserDetails(userUId: string): Observable<UserModel> {
        const url = environment.url + 'User/get-detail?uId=' + userUId;
        return this.http.get(url).pipe(map((response: UserModel) => {
            return response;
        }));
    }
    downloadWorkingSummaryAsCSV(fromDate: string, toDate: string, timeZone: string,driverList :string): Observable<any> {
         // Constructing the query parameters
        const params = new HttpParams().set('driverList', driverList);
    
        const url = environment.url + 'DataToFileConvertor/export-working-summary/' + fromDate + '/' + toDate + '/' + timeZone;
        return this.http.get(url,{params}).pipe(map((response: any) => {
            return response;
        }));
    }
    downloadOrderSummary(fromDate: string, toDate: string, timeZone: string): Observable<any> {
        const url = environment.url + 'DataToFileConvertor/export-order-summary/' + fromDate + '/' + toDate + '/' + timeZone;
        return this.http.get(url).pipe(map((response: any) => {
            return response;
        }));
    }

    downloadTotalOrderSummaryAsCSV(fromDate: string, toDate: string,driverList :string): Observable<any> {
        const params = new HttpParams().set('driverList', driverList);
        const url = environment.url + 'DataToFileConvertor/export-total-order-summary/' + fromDate + '/' + toDate;
        return this.http.get(url,{params}).pipe(map((response: any) => {
            return response;
        }));
    }
    getOnlinePartners(serviceTypeId, countryUId, locationUId): Observable<any[]> {
        const url = environment.url + 'UserService/online-partners/' + serviceTypeId + '/' + countryUId + "?locationUId=" + locationUId;
        return this.http.get(url).pipe(map((response: any[]) => {
            return response;
        }));
    }

    sendBroadCastSMS(model): Observable<any[]> {
        const url = environment.url + 'User/broadcast-sms';
        return this.http.post(url, model).pipe(map((response: any) => {
            return response;
        }));
    }
    sendBroadCastTopic(model): Observable<any[]> {
        const url = environment.url + 'User/broadcast-topic';
        return this.http.post(url, model).pipe(map((response: any) => {
            return response;
        }));
    }
    sendBroadCastNotification(model): Observable<any[]> {
        const url = environment.url + 'User/broadcast-notification';
        return this.http.post(url, model).pipe(map((response: any) => {
            return response;
        }));
    }
    sendBroadCastEmail(model): Observable<any[]> {
        const url = environment.url + 'User/broadcast-email';
        return this.http.post(url, model).pipe(map((response: any) => {
            return response;
        }));
    }

    getReferredUserColumn(languageCode) {
        return [
            {
                field: 'name',
                header: this.localStorage.getSelectedLanguageValue('General.Name'),
                showCheckbox: true,
                isShow: true, width: '15vw'
            },
            {
                field: 'fatherLastName',
                header: this.localStorage.getSelectedLanguageValue('General.FatherLastName'),
                showCheckbox: true,
                isShow: true, width: '15vw'
            },
            {
                field: 'motherLastName',
                header: this.localStorage.getSelectedLanguageValue('General.MotherLastName'),
                showCheckbox: true,
                isShow: true, width: '15vw'
            },
            {
                field: 'email',
                header: this.localStorage.getSelectedLanguageValue('General.Email'),
                isShow: true, width: '20vw'
            },
            {
                field: 'mobileNumber',
                header: this.localStorage.getSelectedLanguageValue('General.MobileNo'),
                isShow: true, width: '11vw'
            },
            {
                field: 'partnerCode',
                header: this.localStorage.getSelectedLanguageValue('General.PartnerCode'),
                isShow: false, width: '10vw'
            },
            {
                field: 'status',
                header: this.localStorage.getSelectedLanguageValue('General.Status'),
                isShow: false, width: '12vw'
            },
            {
                field: 'numberOfTripsOverTotalTrips',
                header: this.localStorage.getSelectedLanguageValue('General.NumberOfTrips'),
                isShow: true, width: '11vw'
            },
            {
                field: 'startDate',
                header: this.localStorage.getSelectedLanguageValue('General.StartDate'),
                isShow: true, width: '10vw'
            },
            {
                field: 'endDate',
                header: this.localStorage.getSelectedLanguageValue('General.EndDate'),
                isShow: true, width: '10vw'
            },
            {
                field: 'remainingDays',
                header: this.localStorage.getSelectedLanguageValue('General.RemainingDays'),
                isShow: true, width: '10vw'
            },
        ];
    }

    getReferredUsers(referredByUId: string) : Observable<ReferredUserModel[]>{
        const url = environment.url + 'User/partner/referred-users/' + referredByUId;
        return this.http.get(url).pipe(map((response: ReferredUserModel[]) => {
            return response;
        }));
    }

    getModifiedByColumn(languageCode) {
        return [
            {
                field: 'modifyBy',
                header: this.localStorage.getSelectedLanguageValue('General.ModifyBy'),
                showCheckbox: true,
                isShow: true, width: '8vw'
            },
            {
                field: 'status',
                header: this.localStorage.getSelectedLanguageValue('General.Status'),
                isShow: false, width: '8vw'
            },
            {
                field: 'modificationDate',
                header: this.localStorage.getSelectedLanguageValue('General.ModificationDate'),
                showCheckbox: true,
                isShow: true, width: '8vw'
            },
            {
                field: 'remarks',
                header: this.localStorage.getSelectedLanguageValue('General.Remarks'),
                isShow: false, width: '8vw'
            },
        ];
    }

    getModificationDetails(userUId: string) : Observable<ModificationDetailsModel[]>{
        const url = environment.url + 'User/get-modification-details/' + userUId;
        return this.http.get(url).pipe(map((response: ModificationDetailsModel[]) => {
            return response;
        }));
    }

    downloadDriverTrasactionHistoryAsCSV(data): Observable<any> {
        const url = environment.url + 'DataToFileConvertor/export-driver-transaction-history';
        return this.http.get(url, { params: data }).pipe(map((response: any) => {
            return response;
        }));
    }

    downloadOrderDetailsAsCSV(fromDate: string, toDate: string, serviceTypeId: number, timeZone: string,driverList :string): Observable<any> {
        const params = new HttpParams().set('driverList', driverList);
        const url = environment.url + 'DataToFileConvertor/driver-order-details/' + fromDate + '/' + toDate + '/' + serviceTypeId + '/' + timeZone;
        return this.http.get(url,{params}).pipe(map((response: any) => {
            return response;
        }));
    }

    downloadDriverOnlineHistoryAsCSV(fromDate: string, toDate: string, timeZone: string,driverList :string): Observable<any> {
        const params = new HttpParams().set('driverList', driverList);
        const url = environment.url + 'DataToFileConvertor/export-driver-online-history/' + fromDate + '/' + toDate + '/' + timeZone;
        return this.http.get(url,{params}).pipe(map((response: any) => {
            return response;
        }));
    }
}
